import { render, staticRenderFns } from "./SnackBarMsg.vue?vue&type=template&id=4ee6ca1e&scoped=true"
import script from "./SnackBarMsg.vue?vue&type=script&lang=js"
export * from "./SnackBarMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee6ca1e",
  null
  
)

export default component.exports